import { useCallback } from 'react'

export interface HasEnoughBalanceParams {
  debitAmount: string
  availableInWallet?: number
}

export interface ShowMinAmountMessageParams {
  debitWallet: any
}

export const useCryptoConversionValidator = () => {
  const hasEnoughBalance = useCallback(
    ({ debitAmount, availableInWallet }: HasEnoughBalanceParams) => {
      const amount = parseFloat(debitAmount || '0')
      const available = availableInWallet || 0

      return amount <= available
    },
    [],
  )

  const showMinAmountMessage = useCallback((_: ShowMinAmountMessageParams) => {
    // This function will be called from ConfirmationButton
    // where the actual toast will be shown
  }, [])

  return {
    hasEnoughBalance,
    showMinAmountMessage,
  }
}
